export default function LocationIcon(){
    return(
        <>
        <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  version="1.1"
                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                  width={14}
                                  height={14}
                                  x={0}
                                  y={0}
                                  viewBox="0 0 512 512"
                                  style={{
                                    enableBackground: "new 0 0 512 512",
                                  }}
                                  xmlSpace="preserve"
                                >
                                  <g>
                                    <path
                                      d="M480.21 239h-55.568c-7.806-81-71.751-143.406-153.751-150.772V31.789c0-8.721-6.779-15.789-15.5-15.789s-15.5 7.068-15.5 15.789v56.473C157.892 95.822 95.594 158 87.802 239H31.79C23.068 239 16 247.779 16 256.5S23.068 274 31.79 274h55.905c7.162 79 70.198 143.573 152.198 151.178v55.032c0 8.721 6.779 15.79 15.5 15.79s15.5-7.068 15.5-15.79v-54.999c82-7.41 146.683-72.212 153.861-151.212h55.458c8.721 0 15.79-8.779 15.79-17.5C496 247.779 488.932 239 480.21 239zM256.223 394.375c-75.903 0-137.655-61.752-137.655-137.655s61.752-137.655 137.655-137.655 137.654 61.752 137.654 137.655-61.751 137.655-137.654 137.655z"
                                      fill="currentColor"
                                      opacity={1}
                                      data-original="#000000"
                                    />
                                    <path
                                      d="M255.985 187.007c-38.308 0-69.474 31.166-69.474 69.474s31.166 69.474 69.474 69.474 69.474-31.166 69.474-69.474-31.167-69.474-69.474-69.474zm0 107.369c-20.895 0-37.895-16.998-37.895-37.895s17-37.895 37.895-37.895 37.895 16.998 37.895 37.895-17 37.895-37.895 37.895z"
                                      fill="currentColor"
                                      opacity={1}
                                      data-original="#000000"
                                    />
                                  </g>
                                </svg>
        </>
    )
}
